import React, {useEffect, useState} from 'react';

import Constants from "../../config/constants";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const SplitComponent = ({topContent, bottomContent}) => {
    const defaultTopClass = "flex-grow-1 sector-route-growing-content";
    const [ isFullscreen, setIsFullscreen] = useState(false);
    const [ topClass, setTopClass] = useState(defaultTopClass);
    const [ topHeight, setTopHeight] = useState('auto');
    const [ bottomHeight, setBottomHeight] = useState('auto');

    const updateLayoutSize = () => {
        // width: window.innerWidth, height: window.innerHeight
        let toRemoveHeight = Constants.headerHeightMobile + 1; //+ this.panelList.current.clientHeight + 1;
        if (window.innerWidth >= 992) {
            toRemoveHeight = Constants.headerHeightDesktop;
        }

        const viewHeight = window.innerHeight - toRemoveHeight;
        const TOP_SIZE = 0.75;
        const BOTTOM_SIZE = 1 - TOP_SIZE;
        let topHeight = 'auto', bottomHeight;

        if (topContent) {
            if (isFullscreen) {
                bottomHeight = 'calc(100vh - ' + toRemoveHeight + 'px)';
                topHeight = (viewHeight * TOP_SIZE) + 'px';
            } else {
                bottomHeight = (viewHeight * BOTTOM_SIZE) + 'px';
                if (bottomContent) {
                    topHeight = (viewHeight * TOP_SIZE) + 'px';
                } else {
                    topHeight = viewHeight + 'px';
                }
            }
        } else {
            bottomHeight = 'calc(100vh - ' + toRemoveHeight + 'px)';
        }

        setTopClass(isFullscreen ? defaultTopClass + ' hide' : defaultTopClass)
        setTopHeight(topHeight);
        setBottomHeight(bottomHeight);
    }

    useEffect(() => {
        updateLayoutSize();
    }, [])

    useEffect(() => {
        updateLayoutSize();
    }, [isFullscreen])

    return (<div className={"flexColumnCenter h-100"}>
            {topContent && <div className={topClass}  style={{height: topHeight}}>
                {topContent}
            </div>}

            {bottomContent && <div style={{height: bottomHeight, overflowY: 'scroll', position: 'relative', }} className="bottom">
                {topContent && <span className={isFullscreen ? 'expandBtn isFullScreen' : 'expandBtn'} onClick={() => setIsFullscreen(!isFullscreen)}>
                    <FontAwesomeIcon icon={["fas", isFullscreen ? "compress" : "expand"]} />
                </span>}
                {bottomContent}
            </div>}
        </div>)
}

export default
    compose(
        withTranslation()
    )(SplitComponent);